import { render, staticRenderFns } from "./newComManagement.vue?vue&type=template&id=6cae404e&scoped=true"
import script from "./newComManagement.vue?vue&type=script&lang=js"
export * from "./newComManagement.vue?vue&type=script&lang=js"
import style0 from "./newComManagement.vue?vue&type=style&index=0&id=6cae404e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cae404e",
  null
  
)

export default component.exports